import { Root } from '~src/components/Root';
import { StepsNorlys } from '~src/components/Steps';
import { usePublicCalculatorContext } from '~src/context/PublicCalculatorContext';

import { InformationPageHeaderMobileNorlys } from './InformationPageHeaderMobileNorlys';
import { useInformationPageStepsNorlys } from '~src/hooks/NorlysInformationPage';

export const InformationPageMobileNorlys = () => {
  const { setHeaderExpanded } = usePublicCalculatorContext();

  const steps = useInformationPageStepsNorlys(true);

  return (
    <Root pageStyle={{ padding: '16px' }} header={<InformationPageHeaderMobileNorlys />}>
      <StepsNorlys
        {...{
          steps,
          lastStepButtonText: 'Se din energiberegning',
          onFinish: () => {
            setHeaderExpanded(true);
          },
        }}
      />
    </Root>
  );
};
